import lodash from 'lodash';
import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { nodeWithArgs, toQuery, node, toMutation } from 'common/util/queryHelper';
import { loadBinder } from 'binder/actions';
import { updateStudyBinder, updateStudySetup } from 'pages/studyOverview/actions/studySettings';
export const LOAD_STUDY = 'LOAD_STUDY';
export const LOAD_STUDY_METADATA_V4 = 'LOAD_STUDY_METADATA_V4';
export const UNLOAD_STUDY = 'UNLOAD_STUDY';
export const UPDATE_STUDY = 'UPDATE_STUDY';
export const UPDATE_STAGE = 'UPDATE_STAGE';
export const LOAD_MY_STUDY_PERMISSIONS = 'LOAD_MY_STUDY_PERMISSIONS';

export function recordBinderBillableHistory(isBillable, binderId) {
    return async (dispatch, getState) => {
        const { me } = getState();
        const userId = me.id;
        const institutionId = lodash.get(me, 'institution.id');
        const input = {
            userId,
            binderId,
            isBillable
        };

        const billableHistoryMutation = nodeWithArgs('createBinderBillableHistory', {
            institutionId,
            input
        });

        return await mutateGraphQL(toMutation(billableHistoryMutation));
    };
}

export function getStudy(studyId) {
    return async dispatch => {
        const query = toQuery([
            nodeWithArgs('study', {
                studyId,
            }, [
                'id',
                'name',
                'binderId',
                'studyTypeId',
                'institutionId',
                'eventsTabEnabled',
                'delegationOfAuthorityEnabled',
                'currentStageId',
                'isMissingDetail',
                'createdAt',
                'updatedAt',
                'createdBy',
                node('binder', [
                    'id',
                    'title',
                    'description',
                    'status',
                    'createdAt',
                    'updatedAt',
                    'trialType',
                    'primaryInvestigator',
                    'irbNumber',
                    'trialId',
                    'departmentSiteDg',
                    'sponsorCro',
                    'ctGovNumber',
                    'contact',
                    'renewalDate',
                    'institutionTimezone',
                    'binderTemplateId',
                    'hasBinderValidationTemplateEnabled',
                    'eventsTabEnabled'
                ]),
                node('createdByUser', [
                    'id',
                    'displayName',
                    'sub',
                    'emailAddress',
                ]),
                node('studyTeam', [
                    'id',
                    'userId',
                    'studyId',
                    'institutionId',
                    'isClinicalStaff',
                    'hasAdminRole',
                    'nameOfResearcher',
                    'studyRoleId',
                    'studyUserType',
                    node('studyRole', [
                        'id',
                        'name',
                    ]),
                    node('user', [
                        'displayName',
                        'sub',
                        'id',
                    ])
                ]),
                node('metadata', [
                    'id',
                    'name',
                    'type',
                    'value',
                    'studyId',
                    'dataType',
                    'descriptorId',
                    'institutionId',
                    'inputFieldType',
                ]),
                node('studyType', [
                    'id',
                    'name',
                    'institutionId',
                    'binderTemplateId',
                    'category',
                ]),
                node('studyRoles', [
                    'id',
                    'name',
                ]),
                node('studyStageProgressions', [
                    'studyId',
                    'currentStageId',
                    'createdAt',
                    'updatedAt',
                ]),
                node('currentStage', [
                    'id',
                    'name',
                ]),
            ]),
            node('me', [
                nodeWithArgs('studyPermissions', {
                    studyId
                }, [
                    node('permissions', [
                        'feature',
                        'action'
                    ]),
                ])
            ])
        ]);

        const response = await queryGraphQL(query);
        const study = response.data.study;

        // if (response && response.errors) {
        //     dispatch(addApplicationMessage('error', 'Failed to fetch study'));
        // } else {
        if (study.binderId) {
            const loadSlimLayout = true;
            dispatch(loadBinder(study.binderId, loadSlimLayout));
        }

        dispatch({
            type: LOAD_STUDY,
            payload: study,
        });
        dispatch({
            type: LOAD_MY_STUDY_PERMISSIONS,
            payload: response.data.me.studyPermissions.permissions,
        });
        // }
    };
}


export function getStudyMetadata(studyId) {
    return async dispatch => {
        const query = toQuery([
            nodeWithArgs('study', {
                studyId,
            }, [
                'id',
                node('metadata', [
                    'id',
                    'name',
                    'type',
                    'value',
                    'studyId',
                    'dataType',
                    'descriptorId',
                    'institutionId',
                    'inputFieldType',
                ]),
            ]),
            node('me', [
                nodeWithArgs('studyPermissions', {
                    studyId
                }, [
                    node('permissions', [
                        'feature',
                        'action'
                    ]),
                ])
            ])
        ]);

        const response = await queryGraphQL(query);
        const study = response.data.study;
        dispatch({
            type: LOAD_STUDY_METADATA_V4,
            payload: study,
        });
    };
}

export function unloadStudy() {
    return dispatch => {
        dispatch({
            type: UNLOAD_STUDY
        });
    };
}

export function updateStudy(study, currentStageId, metadataToAdd, metadataToRemove, notify = true, fetchStudy = true, billable = false) {
    const name = lodash.get(study, 'name');
    const institutionId = lodash.get(study, 'institutionId');
    const studyId = lodash.get(study, 'id');
    const binderId = lodash.get(study, 'binderId');
    const studyTypeId = lodash.get(study, 'studyTypeId');
    const eventsTabEnabled = lodash.get(study, 'eventsTabEnabled');
    const delegationOfAuthorityEnabled = lodash.get(study, 'delegationOfAuthorityEnabled');
    const isMissingDetail = lodash.get(study, 'isMissingDetail');

    const input = {
        id: studyId,
        name,
        institutionId,
        studyTypeId,
        currentStageId,
        eventsTabEnabled,
        delegationOfAuthorityEnabled
    };
    return async (dispatch) => {
        const studyMutation = nodeWithArgs('updateStudy', {
            institutionId,
            isMissingDetail,
            input
        }, [
            'id',
            'institutionId',
            'name',
            'studyTypeId',
            'currentStageId',
            'eventsTabEnabled',
            'delegationOfAuthorityEnabled',
        ]);
        const response = await mutateGraphQL(toMutation(studyMutation));
        if (response && response.errors) {
            return dispatch(addApplicationMessage('error', 'An error occurred when saving.'));
        }

        const updateStudyBinderResponse = await updateStudyBinder(binderId, studyId, name, billable);
        if (updateStudyBinderResponse && updateStudyBinderResponse.errors) {
            return dispatch(addApplicationMessage('error', 'An error occurred while updating study binder.'));
        }

        updateStudySetup(institutionId, studyId, binderId, metadataToAdd, metadataToRemove);

        if (notify) {
            dispatch(addApplicationMessage('success', 'Study updated successfully.'));
        }

        if (fetchStudy) {
            dispatch(getStudy(studyId));
        }

        dispatch({
            type: UPDATE_STUDY,
            payload: response.data.updateStudy,
        });
    };
}

export function updateStage(currentStage) {
    return dispatch => {
        dispatch({
            type: UPDATE_STAGE,
            payload: currentStage,
        });
    };
}
